import React from "react";
import {
  CheckCircleOutline as CheckCircleIcon,
  HourglassEmpty as HourglassIcon,
  CancelOutlined as CancelIcon,
} from "@mui/icons-material";

// Helper to format ISO date string to readable format
export const formatDateTime = (isoString) => {
  if (!isoString) return { date: "—", time: "" };
  try {
    const d = new Date(isoString);
    if (isNaN(d.getTime())) return { date: String(isoString), time: "" };
    const date = d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    const time = d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return { date, time };
  } catch (e) {
    return { date: String(isoString), time: "" };
  }
};

// Helper for status badge styling
export const getStatusChipStyle = (status = "") => {
  const s = String(status).toLowerCase();
  switch (s) {
    case "approved":
      return {
        label: "Approved",
        bg: "#ECFDF5",
        color: "#15803D",
        border: "1px solid #D1FAE5",
        icon: <CheckCircleIcon sx={{ fontSize: 14, color: "#15803D" }} />,
      };
    case "pending":
      return {
        label: "Pending Review",
        bg: "#FFFBEB",
        color: "#D97706",
        border: "1px solid #FEF3C7",
        icon: <HourglassIcon sx={{ fontSize: 14, color: "#D97706" }} />,
      };
    case "rejected":
      return {
        label: "Rejected",
        bg: "#FEF2F2",
        color: "#DC2626",
        border: "1px solid #FEE2E2",
        icon: <CancelIcon sx={{ fontSize: 14, color: "#DC2626" }} />,
      };
    default:
      return {
        label: status ? status.charAt(0).toUpperCase() + status.slice(1) : "Pending",
        bg: "#F1F5F9",
        color: "#64748B",
        border: "1px solid #E2E8F0",
        icon: null,
      };
  }
};

// Helper to extract domain names array from requested_trainer.domains object
export const extractDomains = (domainsObj) => {
  if (!domainsObj) return { fdp: [], techcamp: [], all: [] };
  const fdp = Array.isArray(domainsObj.fdp)
    ? domainsObj.fdp.map((d) => (typeof d === "string" ? d : d.domain_name || d))
    : [];
  const techcamp = Array.isArray(domainsObj.techcamp)
    ? domainsObj.techcamp.map((d) => (typeof d === "string" ? d : d.domain_name || d))
    : [];
  const all = Array.from(new Set([...fdp, ...techcamp]));
  return { fdp, techcamp, all };
};

// Card color themes to make each trainer card visually distinct
export const CARD_THEMES = [
  {
    bg: "#F8FAFC",
    hoverBg: "#F1F5F9",
    border: "#E2E8F0",
    accent: "#2563EB",
    badgeBg: "#EFF6FF",
    badgeText: "#1E40AF",
    badgeBorder: "#DBEAFE",
  },
  {
    bg: "#F0FDF4",
    hoverBg: "#DCFCE7",
    border: "#BBF7D0",
    accent: "#16A34A",
    badgeBg: "#DCFCE7",
    badgeText: "#15803D",
    badgeBorder: "#86EFAC",
  },
  {
    bg: "#FAF5FF",
    hoverBg: "#F3E8FF",
    border: "#E9D5FF",
    accent: "#9333EA",
    badgeBg: "#F3E8FF",
    badgeText: "#7E22CE",
    badgeBorder: "#D8B4FE",
  },
  {
    bg: "#FFFBEB",
    hoverBg: "#FEF3C7",
    border: "#FDE68A",
    accent: "#D97706",
    badgeBg: "#FEF3C7",
    badgeText: "#B45309",
    badgeBorder: "#FCD34D",
  },
  {
    bg: "#F0FDFA",
    hoverBg: "#CCFBF1",
    border: "#99F6E4",
    accent: "#0D9488",
    badgeBg: "#CCFBF1",
    badgeText: "#0F766E",
    badgeBorder: "#5EEAD4",
  },
  {
    bg: "#FFF1F2",
    hoverBg: "#FFE4E6",
    border: "#FECDD3",
    accent: "#E11D48",
    badgeBg: "#FFE4E6",
    badgeText: "#BE123C",
    badgeBorder: "#FDA4AF",
  },
];
